import DashboardPassportFileModal from "./DashboardPassportFileModal";

export default DashboardPassportFileModal;
